import { Injectable } from '@angular/core';
import { CeIconInterface } from '@enginuity/core/atoms/ce-icon/ce-icon.model';
import { all_icons } from '@enginuity/core/atoms/ce-icon/ce-all-icons';

@Injectable({
  providedIn: 'root',
})
export class CeIconRegisteryService {
  constructor() {
    all_icons.forEach((icon: CeIconInterface) => this.registry.set(icon.name, icon.data));
  }

  private registry = new Map<string, string>();

  public getIcon(iconName: string): string | undefined {
    if (!this.registry.has(iconName)) {
      return '';
    }
    return this.registry.get(iconName);
  }
}
